__turbopack_context__.v({
  "ab": "flag-module-scss-module__tTy4Wa__ab",
  "flag": "flag-module-scss-module__tTy4Wa__flag",
  "name": "flag-module-scss-module__tTy4Wa__name",
  "override": "flag-module-scss-module__tTy4Wa__override",
  "tag": "flag-module-scss-module__tTy4Wa__tag",
  "tags": "flag-module-scss-module__tTy4Wa__tags",
});
